
import { Component, Vue } from "vue-property-decorator";

import { getIconFromUnitableType, getTitleFromUnitableType } from "@/helpers";

import { EUnitableType } from "@/models/unit/unit_version";

@Component({
  name: "CProgramMaterialsAdd"
})
export default class CProgramMaterialsAdd extends Vue {
  public getIconFromUnitableType = getIconFromUnitableType;
  public getTitleFromUnitableType = getTitleFromUnitableType;

  public materials_list: Array<{ type: string; icon: string }> = Object.keys(
    EUnitableType
  )
    .slice(0, 4)
    .map(t => {
      return {
        type: t,
        icon: getIconFromUnitableType(t)
      };
    });

  public selectMaterial(type: string) {
    this.$emit("selected", type);
  }
}
